/** Release hardware immediately on close/background, including its torch. */
export function releaseCamera(stream: MediaStream | null, video: HTMLVideoElement | null): void {
  stream?.getTracks().forEach(track => track.stop());
  if (video) {
    video.pause();
    video.srcObject = null;
  }
}
